import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// import useWebConfig from 'hooks/useWebConfig';
// import NotFoundPage from 'pages/Page404';
// project import
import useAuth from 'hooks/useAuth';
import PushBootstrap from 'components/notifications/PushBootstrap';
// import useWebConfig from 'hooks/useWebConfig';

// ==============================|| AUTH GUARD ||============================== //

const AuthGuard = ({ children }) => {
  const { isLoggedIn } = useAuth();
  // const { getWebConfigAction, resetWebConfig } = useWebConfig();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('login', {
        state: {
          from: location.pathname
        },
        replace: true
      });
      navigate('login', { replace: true });
    }
  }, [isLoggedIn, navigate, location]);

  // useLayoutEffect(() => {
  //   getWebConfigAction();
  //   resetWebConfig();
  // }, []);

  return (
    <>
      {/* Keeps this browser registered for platform alerts and asks for the
          permission the first time round. Renders only its opt-in card, so it
          is safe to mount above every guarded route. */}
      <PushBootstrap />
      {children}
    </>
  );
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
